import * as React from 'react'
import classNames from 'classnames'

import type { HeaderVariant } from './TableHead'
import type { TableHeaderType } from '../../types'
import TableHead from './TableHead'
import style from './style.scss'

export type BasicRow = Array<string | number>

export type RowVariant = 'zebra' | 'underline'

export type Props = {
  className?: string
  data: Array<BasicRow>
  header?: Array<TableHeaderType>
  headerVariant?: HeaderVariant
  rowVariant?: RowVariant
}

function SimpleTable({
  className,
  data,
  header,
  headerVariant = 'normal',
  rowVariant = 'zebra',
}: Props) {
  return (
    <table className={classNames(style.wrapper, className)}>
      {header && <TableHead columns={header} variant={headerVariant} />}
      <tbody>
        {data.map((row, index) => (
          <tr key={index} className={style[rowVariant]}>
            {row.map((value) => (
              <td key={value} className={style.tableCell}>
                {value}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default SimpleTable
